/*--------------------------------------------------------------------------*
 * 求人一覧ページ
 *--------------------------------------------------------------------------*/
module Module_JobSearchResult {
	export class Model_JobSearchResult {
		// mainがsideより短いとき高さを合わせる
		resizeMain(main: JQuery, side: JQuery, exHeight: number): void {
			const mainHeight: number = main.height(),
				sideHeight: number   = side.height() + exHeight;
			if(mainHeight < sideHeight) {
				main.height(sideHeight);
			}
		}
	}
}
